module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /payu/microservice/multichannelportal/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main